export default __webpack_public_path__ + "static/media/call_tools.02f8973c.png";